<template>
  <v-application-view title="Organizations">
    <v-layout row class="mx-1">
      <v-flex class="px-2 pt-2" md6>
        <v-card tile outlined>
          <v-data-table v-bind:headers="headers" v-bind:items="items" v-on:click:row="open">
            <template v-slot:item.organization={item}>
              <v-list-item class="px-0">
                <v-list-item-content>
                  <v-list-item-title>{{item.name}}</v-list-item-title>
                  <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-application-view>
</template>
<script>
export default {
  name: 'Organizations',
  data: () => ({
    headers: [
      {text: 'Name', value: 'organization'}
    ],
    items: [
      {id: 1, name: 'Asia Alliance Bank', description: 'The main of Bank of our company'},
      {id: 2, name: 'Express24', description: 'Delivery services'},
    ]
  }),
  methods: {
    open(item){
      this.$router.push({name: 'organization', params: {
        id: item.id
      }, query: {
        back: this.$route.name
      }})
    }
  }
}
</script>
